// src/components/home/WhyRobomind.js
// Homepage differentiators grid.
import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionTitle from '../SectionTitle';

const WhyRobomind = () => {
    const { t } = useTranslation();
    const items = t('home.why.items', { returnObjects: true }) || [];

    return (
        <div className="bg-white py-12">
            <section data-aos="fade-up">
                <SectionTitle title={t('home.why.title')} />
                <div className="max-w-7xl mx-auto px-4 sm:px-8 mt-6">
                    <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {Array.isArray(items) && items.map((item, i) => (
                            <div key={i} className="border border-gray-200 rounded-xl p-6 hover:border-primary transition-colors duration-300" data-aos="fade-up" data-aos-delay={i * 100}>
                                <h3 className="font-bold text-lg text-gray-800 mb-2">{item.title}</h3>
                                <p className="text-gray-600 text-justify">{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default WhyRobomind;
